import axios from "axios";
import FeatherIcon from "feather-icons-react";
import React, { Component } from "react";
import { Link } from "react-router-dom";

class Search extends Component {
    state = { data: [], loading: true, error: false };
    _isMounted = false;

    componentDidMount() { this._isMounted = true; this.getData(); }
    componentWillUnmount() { this._isMounted = false; }
    componentDidUpdate(previousProps) {
        if (previousProps.match.params.search !== this.props.match.params.search) this.getData();
    }

    getData = async () => {
        const search = this.props.match.params.search || "";
        this.setState({ loading: true, error: false });
        try {
            const response = await axios.get("users/search/" + encodeURIComponent(search));
            if (this._isMounted) this.setState({
                data: response.status === 200 && Array.isArray(response.data) ? response.data : [], loading: false
            });
        } catch (error) {
            if (this._isMounted) this.setState({ data: [], loading: false, error: true });
        }
    };

    getProfile = (user = {}) => {
        const student = user.students || user.student;
        if (student && student.id) return { path: "/students/" + student.id, label: "\u00c9l\u00e8ve", matricule: student.matricule || "Sans matricule", year: student.year?.year || null, status: student.year?.status || null };
        if (user.staff && user.staff.id) return { path: "/staffs/" + user.staff.id, label: "Personnel", matricule: user.staff.matricule || "Sans matricule", year: user.staff?.year?.year || null, status: user.staff?.year?.status || null };
        return { path: null, label: "Parent", matricule: "Profil non associ\u00e9", year: null, status: null };
    };

    getName = (user = {}) => [user.last_name, user.family_name, user.first_name].filter(Boolean).join(" ") || "Profil sans nom";
    getInitials = (user = {}) => [user.last_name || user.family_name, user.first_name].filter(Boolean).map((name) => String(name).charAt(0)).join("").slice(0, 2).toUpperCase() || "UT";

    renderUser = (user) => {
        const profile = this.getProfile(user);
        const content = <>
            <span className="user-search-avatar">{user.avatar ? <img src={user.avatar} alt="" /> : <i>{this.getInitials(user)}</i>}</span>
            <span className="user-search-card__identity"><span className="user-search-card__type">{profile.label}</span><strong>{this.getName(user)}</strong><small>{profile.matricule} <b className={profile.status === 1 ? "text-primary" : "text-danger"}>{profile.year}</b></small></span>
            <span className="user-search-card__arrow" aria-hidden="true"><FeatherIcon icon={profile.path ? "arrow-up-right" : "user-x"} size="17" /></span>
        </>;
        return profile.path ? <Link className="user-search-card" to={profile.path} key={user.id}>{content}</Link> : <article className="user-search-card is-disabled" key={user.id}>{content}</article>;
    };

    render() {
        const { data, loading, error } = this.state;
        const search = this.props.match.params.search || "";
        return <main className="ev-page user-search-page">
            <header className="ev-page-header user-search-header">
                <div className="ev-page-header__content"><span className="ev-page-header__eyebrow"><FeatherIcon icon="search" size="14" /> Recherche globale</span><h1>R&eacute;sultats pour &laquo; {search} &raquo;</h1><p>Retrouvez rapidement les &eacute;l&egrave;ves et les membres du personnel correspondants.</p></div>
                {!loading && !error && <div className="ev-page-header__actions"><span className="user-search-count"><FeatherIcon icon="users" size="16" /><strong>{data.length}</strong> r&eacute;sultat{data.length > 1 ? "s" : ""}</span></div>}
            </header>
            <section className="staff-panel user-search-panel">
                <div className="staff-panel-title"><i><FeatherIcon icon="users" size="18" /></i><div><span>Annuaire</span><h2>Profils correspondants</h2></div>{!loading && !error && data.length > 0 && <button type="button" onClick={this.getData}><FeatherIcon icon="refresh-cw" size="15" /> Actualiser</button>}</div>
                {loading && <div className="staff-state" role="status"><FeatherIcon className="user-search-spin" icon="loader" /><h3>Recherche en cours</h3><p>Nous parcourons l&rsquo;annuaire de l&rsquo;&eacute;tablissement.</p></div>}
                {!loading && error && <div className="staff-state error"><FeatherIcon icon="alert-circle" /><h3>Recherche indisponible</h3><p>Impossible de r&eacute;cup&eacute;rer les r&eacute;sultats pour le moment.</p><button type="button" onClick={this.getData}>R&eacute;essayer</button></div>}
                {!loading && !error && data.length === 0 && <div className="staff-state"><FeatherIcon icon="user-x" /><h3>Aucun profil trouv&eacute;</h3><p>Essayez une autre orthographe ou un terme plus court.</p></div>}
                {!loading && !error && data.length > 0 && <div className="user-search-grid">{data.map(this.renderUser)}</div>}
            </section>
        </main>;
    }
}

export default Search;
